module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABVklEQVQ4jZ3TP0iVURjH8Y+3WqV/i+LS0qIEcRHKyV2IFoMWEcE7SEFUQyhOCg7+hQy8dXNwUAcnuWPkpkhRg0JjQ1E05eYUNZxz5PRy0Xv9Lc/hfZ73e57D83vaKpWKgm7jCe6jPX77iQ0s4nteXK1WlQqAFXzCED5jCS/xC0/xLcb/dDE776Afk5guFuJyhM7jBh4XIW8joA97DQBwhGF8wDIOUYUSbmIEz08B5HqFd8LTLyXIbEzONwFIehDjWILcw3oLAPiNH8IATqbTzDOKOkBHDimOuln9zX++cw5At2i8EjbxsEXAVXShliDjMfGsBchajG8S5CsWMCcY7iw9woBgTAmSutgSrD8jmqigK3gt7BJcT4l8dwaFnZnAC+ziS8zdQm9W14ltjKJ2oVwu57e9x2o89+CuMIVjweaD+Ij92MBcvV7/k3eS1HDdG2gS1zD1D9aZQMazL6yQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/searchicon.png
// module id = Bvy5
// module chunks = 1